export const CATEGORIES = [
  { id: "tai-lieu",  label: "Tài liệu",           icon: "📄", color: "#1d4ed8" },
  { id: "roadmap",  label: "Roadmap ngành",        icon: "🗺️", color: "#059669" },
  { id: "cv",       label: "CV mẫu",               icon: "📋", color: "#7c3aed" },
  { id: "interview",label: "Interview Q&A",        icon: "💬", color: "#d97706" },
  { id: "github",   label: "GitHub hay",           icon: "🐙", color: "#374151" },
  { id: "khoa-hoc", label: "Khóa học miễn phí",   icon: "🎓", color: "#dc2626" },
  { id: "nckh",     label: "Nghiên cứu KH",        icon: "🔬", color: "#0891b2" },
];

export const RESOURCES = {
  /* ─────────────── TÀI LIỆU ─────────────── */
  "tai-lieu": [
    {
      icon: "🏆",
      name: "VNOI Wiki",
      platform: "vnoi.info",
      desc: "Kho tài liệu giải thuật và lập trình thi đấu do cộng đồng lập trình viên Việt Nam xây dựng. Bao gồm CTDL, thuật toán, competitive programming.",
      tags: ["Tiếng Việt", "Miễn phí", "Giải thuật"],
      url: "https://vnoi.info/wiki/",
      highlight: true,
    },
    {
      icon: "🌐",
      name: "MDN Web Docs",
      platform: "developer.mozilla.org",
      desc: "Tài liệu chuẩn và đầy đủ nhất về HTML, CSS, JavaScript và Web API. Tham chiếu chính thức cho mọi lập trình viên web toàn cầu.",
      tags: ["Tiếng Anh", "Miễn phí", "Web"],
      url: "https://developer.mozilla.org/",
      highlight: true,
    },
    {
      icon: "⚡",
      name: "JavaScript.info",
      platform: "javascript.info",
      desc: "Tài liệu học JavaScript hiện đại chất lượng nhất — từ cơ bản đến nâng cao: Closure, Promises, Async/Await, DOM, Events, Modules.",
      tags: ["Tiếng Anh", "Miễn phí", "JavaScript"],
      url: "https://javascript.info/",
      highlight: true,
    },
    {
      icon: "🧠",
      name: "GeeksForGeeks",
      platform: "geeksforgeeks.org",
      desc: "Cổng thông tin CS với hàng nghìn bài về CTDL, giải thuật, hệ thống, OOP và phỏng vấn kỹ thuật theo từng ngôn ngữ lập trình.",
      tags: ["Tiếng Anh", "Miễn phí", "CS Fundamentals"],
      url: "https://www.geeksforgeeks.org/",
    },
    {
      icon: "📝",
      name: "Viblo",
      platform: "viblo.asia",
      desc: "Nền tảng chia sẻ kiến thức công nghệ lớn nhất Việt Nam. Hàng nghìn bài về các công nghệ mới nhất từ cộng đồng developer Việt.",
      tags: ["Tiếng Việt", "Miễn phí", "Blog"],
      url: "https://viblo.asia/",
    },
    {
      icon: "🎨",
      name: "CSS-Tricks",
      platform: "css-tricks.com",
      desc: "Tài nguyên số một về CSS: flexbox, grid, animation, custom properties. Bao gồm cả snippet code và các bài giải thích cực kỳ chi tiết.",
      tags: ["Tiếng Anh", "Miễn phí", "CSS/Frontend"],
      url: "https://css-tricks.com/",
    },
    {
      icon: "🎓",
      name: "The Missing Semester — MIT",
      platform: "missing.csail.mit.edu",
      desc: "Khóa học của MIT dạy những kỹ năng thiết yếu mà trường đại học không dạy: Terminal, Git, Vim, Shell scripting, Debugging, Security.",
      tags: ["Tiếng Anh", "Miễn phí", "Dev Tools"],
      url: "https://missing.csail.mit.edu/",
      highlight: true,
    },
    {
      icon: "🔮",
      name: "Refactoring.Guru",
      platform: "refactoring.guru",
      desc: "Tài nguyên trực quan về Design Patterns và Refactoring. Giải thích các pattern bằng hình ảnh sinh động, ví dụ code nhiều ngôn ngữ.",
      tags: ["Tiếng Anh", "Miễn phí", "Design Patterns"],
      url: "https://refactoring.guru/",
    },
    {
      icon: "📚",
      name: "DevDocs.io",
      platform: "devdocs.io",
      desc: "Tổng hợp tài liệu API của hơn 100 công nghệ trong một giao diện: React, Node, Python, Docker, SQL, Laravel và nhiều hơn nữa.",
      tags: ["Tiếng Anh", "Miễn phí", "API Reference"],
      url: "https://devdocs.io/",
    },
    {
      icon: "🇻🇳",
      name: "Codelearn.io",
      platform: "codelearn.io",
      desc: "Nền tảng học lập trình tiếng Việt với khóa học C++, Python, Java, Web. Thực hành trực tiếp trên trình duyệt, có bài tập và chấm tự động.",
      tags: ["Tiếng Việt", "Freemium", "Interactive"],
      url: "https://codelearn.io/",
    },
    {
      icon: "📖",
      name: "Pro Git Book",
      platform: "git-scm.com",
      desc: "Sách Git chính thức — miễn phí hoàn toàn. Từ cơ bản đến Git Internals, branching strategies, rebasing và làm việc nhóm với Git.",
      tags: ["Tiếng Anh", "Miễn phí", "Git/DevOps"],
      url: "https://git-scm.com/book/en/v2",
    },
    {
      icon: "🐍",
      name: "Real Python",
      platform: "realpython.com",
      desc: "Hàng trăm tutorial Python chất lượng cao: từ cơ bản, OOP, Web Scraping, Django, FastAPI, Data Science đến automation.",
      tags: ["Tiếng Anh", "Freemium", "Python"],
      url: "https://realpython.com/",
    },
    {
      icon: "🌊",
      name: "Dive into Deep Learning",
      platform: "d2l.ai",
      desc: "Sách học Deep Learning tương tác miễn phí từ các kỹ sư Amazon AI. Code chạy được ngay trên trình duyệt với PyTorch/TensorFlow.",
      tags: ["Tiếng Anh", "Miễn phí", "AI/ML"],
      url: "https://d2l.ai/",
    },
    {
      icon: "🔧",
      name: "Exercism.io",
      platform: "exercism.org",
      desc: "Luyện tập kỹ năng lập trình qua 70+ ngôn ngữ với mentor review thực tế. Phù hợp luyện thêm ngôn ngữ mới sau giờ học.",
      tags: ["Tiếng Anh", "Miễn phí", "Practice"],
      url: "https://exercism.org/",
    },
    {
      icon: "🧩",
      name: "CodeWars",
      platform: "codewars.com",
      desc: "Giải kata lập trình theo cấp độ (8 kyu → 1 kyu). Gamified learning giúp rèn kỹ năng giải thuật theo kiểu thú vị và hấp dẫn.",
      tags: ["Tiếng Anh", "Miễn phí", "Practice"],
      url: "https://www.codewars.com/",
    },
    {
      icon: "🖥️",
      name: "Linux Command",
      platform: "linuxcommand.org",
      desc: "Học lệnh Linux từ cơ bản đến nâng cao: file system, permissions, shell scripting, text processing. Kỹ năng bắt buộc cho mọi lập trình viên.",
      tags: ["Tiếng Anh", "Miễn phí", "Linux/DevOps"],
      url: "https://linuxcommand.org/",
    },
    {
      icon: "🌍",
      name: "web.dev — Google",
      platform: "web.dev",
      desc: "Hướng dẫn của Google về web performance, accessibility, PWA, Core Web Vitals và các best practices phát triển web hiện đại.",
      tags: ["Tiếng Anh", "Miễn phí", "Web/Performance"],
      url: "https://web.dev/",
    },
    {
      icon: "🗃️",
      name: "SQLZoo",
      platform: "sqlzoo.net",
      desc: "Học SQL tương tác trực tuyến — thực hành trực tiếp trên browser với nhiều dataset thực tế. Bao gồm SELECT, JOIN, GROUP BY đến Window Functions.",
      tags: ["Tiếng Anh", "Miễn phí", "Database/SQL"],
      url: "https://sqlzoo.net/",
    },
    {
      icon: "🔌",
      name: "RegexLearn",
      platform: "regexlearn.com",
      desc: "Học Regular Expression theo cách gamified, trực quan và dễ hiểu. Từ cú pháp cơ bản đến lookahead/lookbehind phức tạp.",
      tags: ["Tiếng Anh", "Miễn phí", "Tools"],
      url: "https://regexlearn.com/",
    },
    {
      icon: "📡",
      name: "ByteByteGo Blog",
      platform: "blog.bytebytego.com",
      desc: "Newsletter và blog về system design, kiến trúc hệ thống quy mô lớn. Giải thích các khái niệm phức tạp qua infographic đẹp và dễ hiểu.",
      tags: ["Tiếng Anh", "Freemium", "System Design"],
      url: "https://blog.bytebytego.com/",
    },
  ],

  /* ─────────────── ROADMAP ─────────────── */
  "roadmap": [
    {
      icon: "🖥️",
      name: "Frontend Developer",
      platform: "roadmap.sh/frontend",
      desc: "Lộ trình học Frontend từ HTML/CSS/JS cơ bản đến React, TypeScript, Performance Optimization, Testing và các công nghệ hiện đại.",
      tags: ["Tiếng Anh", "Miễn phí", "Frontend"],
      url: "https://roadmap.sh/frontend",
      highlight: true,
    },
    {
      icon: "⚙️",
      name: "Backend Developer",
      platform: "roadmap.sh/backend",
      desc: "Lộ trình Backend bao gồm ngôn ngữ, database, API, caching, message broker, authentication, microservices và kiến trúc hệ thống.",
      tags: ["Tiếng Anh", "Miễn phí", "Backend"],
      url: "https://roadmap.sh/backend",
      highlight: true,
    },
    {
      icon: "🤖",
      name: "AI & Data Science",
      platform: "roadmap.sh/ai-data-scientist",
      desc: "Lộ trình cho AI/ML Engineer: Python, Math, ML algorithms, Deep Learning, frameworks (TensorFlow, PyTorch) và MLOps.",
      tags: ["Tiếng Anh", "Miễn phí", "AI/ML"],
      url: "https://roadmap.sh/ai-data-scientist",
    },
    {
      icon: "☁️",
      name: "DevOps & Cloud",
      platform: "roadmap.sh/devops",
      desc: "Lộ trình DevOps: Linux, Networking, Docker, Kubernetes, CI/CD, Cloud providers (AWS/GCP/Azure) và Infrastructure as Code.",
      tags: ["Tiếng Anh", "Miễn phí", "DevOps"],
      url: "https://roadmap.sh/devops",
    },
    {
      icon: "📱",
      name: "Android Developer",
      platform: "roadmap.sh/android",
      desc: "Lộ trình phát triển Android: Kotlin, Jetpack Compose, Architecture patterns (MVVM/MVI), Testing và Google Play publishing.",
      tags: ["Tiếng Anh", "Miễn phí", "Mobile"],
      url: "https://roadmap.sh/android",
    },
    {
      icon: "🍎",
      name: "iOS Developer",
      platform: "roadmap.sh/ios",
      desc: "Lộ trình iOS: Swift, SwiftUI, UIKit, Xcode, Core Data, Networking, Testing và App Store submission process.",
      tags: ["Tiếng Anh", "Miễn phí", "Mobile"],
      url: "https://roadmap.sh/ios",
    },
    {
      icon: "🔒",
      name: "Cybersecurity",
      platform: "roadmap.sh/cyber-security",
      desc: "Lộ trình An toàn thông tin: Networking, OS, Web Security, Cryptography, Penetration Testing và các chứng chỉ (CEH, OSCP).",
      tags: ["Tiếng Anh", "Miễn phí", "Security"],
      url: "https://roadmap.sh/cyber-security",
    },
    {
      icon: "🗄️",
      name: "Full Stack Developer",
      platform: "roadmap.sh/full-stack",
      desc: "Lộ trình Full Stack kết hợp Frontend + Backend, cho cái nhìn toàn diện về phát triển web từ UI đến database và deployment.",
      tags: ["Tiếng Anh", "Miễn phí", "Full Stack"],
      url: "https://roadmap.sh/full-stack",
    },
    {
      icon: "⚛️",
      name: "React Developer",
      platform: "roadmap.sh/react",
      desc: "Lộ trình chuyên sâu React: Hooks, Context, Redux, React Query, Testing, Performance và các ecosystem xung quanh.",
      tags: ["Tiếng Anh", "Miễn phí", "Frontend/React"],
      url: "https://roadmap.sh/react",
    },
    {
      icon: "🟢",
      name: "Node.js Developer",
      platform: "roadmap.sh/nodejs",
      desc: "Lộ trình Node.js: Event Loop, Streams, Express, NestJS, Database (SQL/NoSQL), Authentication, Testing và deployment.",
      tags: ["Tiếng Anh", "Miễn phí", "Backend/Node"],
      url: "https://roadmap.sh/nodejs",
    },
    {
      icon: "🐍",
      name: "Python Developer",
      platform: "roadmap.sh/python",
      desc: "Lộ trình Python toàn diện: từ cơ bản đến Web (Django/FastAPI), Data Science, ML, Automation và Scripting.",
      tags: ["Tiếng Anh", "Miễn phí", "Python"],
      url: "https://roadmap.sh/python",
    },
    {
      icon: "🦋",
      name: "Flutter Developer",
      platform: "roadmap.sh/flutter",
      desc: "Lộ trình Flutter: Dart, Widget tree, State management (Bloc/Riverpod), API integration, Firebase và publish app.",
      tags: ["Tiếng Anh", "Miễn phí", "Mobile/Flutter"],
      url: "https://roadmap.sh/flutter",
    },
    {
      icon: "🗄️",
      name: "PostgreSQL DBA",
      platform: "roadmap.sh/postgresql-dba",
      desc: "Lộ trình Database Administrator: cài đặt, cấu hình, query optimization, indexing, backup/restore và replication.",
      tags: ["Tiếng Anh", "Miễn phí", "Database"],
      url: "https://roadmap.sh/postgresql-dba",
    },
    {
      icon: "🎮",
      name: "Game Developer",
      platform: "roadmap.sh/game-developer",
      desc: "Lộ trình Game Development: ngôn ngữ (C#/C++), game engines (Unity/Unreal), physics, rendering, audio và monetization.",
      tags: ["Tiếng Anh", "Miễn phí", "Game Dev"],
      url: "https://roadmap.sh/game-developer",
    },
    {
      icon: "🧠",
      name: "AI Engineer",
      platform: "roadmap.sh/ai-engineer",
      desc: "Lộ trình AI Engineer 2024: LLMs, Prompt Engineering, RAG, Vector Databases, Fine-tuning và triển khai AI production.",
      tags: ["Tiếng Anh", "Miễn phí", "AI/LLM"],
      url: "https://roadmap.sh/ai-engineer",
      highlight: true,
    },
    {
      icon: "🔗",
      name: "Computer Science",
      platform: "roadmap.sh/computer-science",
      desc: "Lộ trình CS tổng quát: từ nền tảng toán, CTDL, giải thuật, OS, Mạng máy tính đến Database và Software Engineering.",
      tags: ["Tiếng Anh", "Miễn phí", "CS Fundamentals"],
      url: "https://roadmap.sh/computer-science",
    },
  ],

  /* ─────────────── CV MẪU ─────────────── */
  "cv": [
    {
      icon: "🎓",
      name: "Overleaf CV Templates",
      platform: "overleaf.com",
      desc: "Kho template CV LaTeX chuyên nghiệp được dùng nhiều nhất cho sinh viên kỹ thuật. Soạn thảo và tải PDF trực tuyến ngay trên browser.",
      tags: ["Tiếng Anh", "Miễn phí", "LaTeX"],
      url: "https://www.overleaf.com/gallery/tagged/cv",
      highlight: true,
    },
    {
      icon: "✨",
      name: "FlowCV",
      platform: "flowcv.com",
      desc: "Công cụ tạo CV online trực quan, nhiều template đẹp cho IT. ATS-friendly, dễ xuất PDF. Rất phổ biến với fresher developer Việt Nam.",
      tags: ["Tiếng Anh", "Freemium", "Online Tool"],
      url: "https://flowcv.com/",
      highlight: true,
    },
    {
      icon: "🚀",
      name: "Reactive Resume",
      platform: "rxresu.me",
      desc: "CV builder mã nguồn mở, hoàn toàn miễn phí, không watermark. Nhiều template đẹp, hỗ trợ JSON import/export và real-time preview.",
      tags: ["Tiếng Anh", "Miễn phí", "Open Source"],
      url: "https://rxresu.me/",
      highlight: true,
    },
    {
      icon: "🎨",
      name: "Canva CV Templates",
      platform: "canva.com",
      desc: "Kho template CV đa dạng với giao diện kéo thả. Phù hợp tạo CV có thiết kế đẹp mắt, cá nhân hóa cao và chuyên nghiệp.",
      tags: ["Tiếng Việt", "Freemium", "Design Tool"],
      url: "https://www.canva.com/resumes/templates/",
    },
    {
      icon: "💼",
      name: "TopDev CV Builder",
      platform: "topdev.vn",
      desc: "Công cụ tạo CV của nền tảng tuyển dụng IT Việt Nam. CV được tối ưu cho thị trường công nghệ Việt, dễ đăng ký việc làm trực tiếp.",
      tags: ["Tiếng Việt", "Miễn phí", "IT-focused"],
      url: "https://topdev.vn/cv-builder/",
    },
    {
      icon: "📄",
      name: "Jake's Resume (LaTeX)",
      platform: "github.com/jakegut",
      desc: "Template CV LaTeX nổi tiếng nhất dành cho Software Engineer — đơn giản, ATS-friendly, rất phổ biến trong cộng đồng CS quốc tế.",
      tags: ["Tiếng Anh", "Miễn phí", "LaTeX"],
      url: "https://github.com/jakegut/resume",
    },
    {
      icon: "📋",
      name: "Resume.io",
      platform: "resume.io",
      desc: "Nền tảng tạo CV chuyên nghiệp với template ATS-friendly, hướng dẫn điền nội dung từng phần và gợi ý content thông minh.",
      tags: ["Tiếng Anh", "Freemium", "ATS-friendly"],
      url: "https://resume.io/",
    },
    {
      icon: "💡",
      name: "Tech Interview Handbook — CV",
      platform: "techinterviewhandbook.org",
      desc: "Hướng dẫn viết CV cho Software Engineer từ cựu kỹ sư Meta/Google. Tập trung ATS optimization, action verbs và quantified metrics.",
      tags: ["Tiếng Anh", "Miễn phí", "Tips & Guide"],
      url: "https://www.techinterviewhandbook.org/resume/",
    },
    {
      icon: "📊",
      name: "JSON Resume",
      platform: "jsonresume.org",
      desc: "Chuẩn mở cho CV dưới dạng JSON. Viết CV 1 lần, render ra nhiều theme đẹp khác nhau. Lập trình viên thích cái này lắm.",
      tags: ["Tiếng Anh", "Miễn phí", "Developer-friendly"],
      url: "https://jsonresume.org/",
    },
    {
      icon: "🔵",
      name: "LinkedIn Profile Optimization",
      platform: "linkedin.com",
      desc: "Tối ưu hóa hồ sơ LinkedIn để nhà tuyển dụng chủ động tìm đến. LinkedIn là mạng tuyển dụng IT lớn nhất — không thể thiếu.",
      tags: ["Đa ngôn ngữ", "Miễn phí", "Networking"],
      url: "https://www.linkedin.com/",
    },
    {
      icon: "🎯",
      name: "CV Compiler — Review tự động",
      platform: "cvcompiler.com",
      desc: "AI review CV cho Software Engineer: phân tích từng phần, gợi ý cải thiện theo tiêu chí nhà tuyển dụng công nghệ thực tế.",
      tags: ["Tiếng Anh", "Freemium", "AI Tool"],
      url: "https://cvcompiler.com/",
    },
    {
      icon: "🏷️",
      name: "ITViec — CV & Tuyển dụng IT VN",
      platform: "itviec.com",
      desc: "Nền tảng việc làm IT lớn nhất Việt Nam. Xem mức lương thực tế theo vị trí, tạo hồ sơ và apply thẳng đến các công ty tech.",
      tags: ["Tiếng Việt", "Miễn phí", "Job Market"],
      url: "https://itviec.com/",
    },
  ],

  /* ─────────────── INTERVIEW ─────────────── */
  "interview": [
    {
      icon: "⚡",
      name: "LeetCode",
      platform: "leetcode.com",
      desc: "Nền tảng luyện bài thuật toán & CTDL lớn nhất thế giới. 3000+ bài từ Easy đến Hard, mock interview, weekly contest và discussion.",
      tags: ["Tiếng Anh", "Freemium", "DSA"],
      url: "https://leetcode.com/",
      highlight: true,
    },
    {
      icon: "🎯",
      name: "NeetCode",
      platform: "neetcode.io",
      desc: "Road map 150 bài LeetCode được tổ chức theo pattern rõ ràng (Sliding Window, Two Pointers, Tree...) kèm giải thích video dễ hiểu.",
      tags: ["Tiếng Anh", "Miễn phí", "DSA"],
      url: "https://neetcode.io/",
      highlight: true,
    },
    {
      icon: "📘",
      name: "Coding Interview University",
      platform: "github.com/jwasham",
      desc: "Kế hoạch học 8–26 tuần chuẩn bị phỏng vấn Google, Amazon, Facebook. Tổng hợp toàn bộ kiến thức CS: CTDL, OS, Mạng, DB.",
      tags: ["Tiếng Anh", "Miễn phí", "Full Guide"],
      url: "https://github.com/jwasham/coding-interview-university",
    },
    {
      icon: "🏗️",
      name: "System Design Primer",
      platform: "github.com/donnemartin",
      desc: "Học thiết kế hệ thống phân tán cho phỏng vấn System Design: scalability, load balancing, caching, databases, microservices.",
      tags: ["Tiếng Anh", "Miễn phí", "System Design"],
      url: "https://github.com/donnemartin/system-design-primer",
    },
    {
      icon: "🎯",
      name: "Tech Interview Handbook",
      platform: "techinterviewhandbook.org",
      desc: "Hướng dẫn toàn diện quá trình phỏng vấn: từ viết CV, apply job, đến các giai đoạn phỏng vấn kỹ thuật và thương lượng lương.",
      tags: ["Tiếng Anh", "Miễn phí", "Full Guide"],
      url: "https://www.techinterviewhandbook.org/",
    },
    {
      icon: "🎨",
      name: "Frontend Interview Handbook",
      platform: "frontendinterviewhandbook.com",
      desc: "Câu hỏi phỏng vấn Frontend: HTML/CSS/JS, React, Browser, Performance, Accessibility, Web Security và System Design cho Frontend.",
      tags: ["Tiếng Anh", "Miễn phí", "Frontend"],
      url: "https://www.frontendinterviewhandbook.com/",
    },
    {
      icon: "🔍",
      name: "Blind 75 — Must-do List",
      platform: "leetcode.com",
      desc: "75 bài LeetCode được kỹ sư Facebook chọn lọc — tập trung vào patterns quan trọng nhất: Array, DP, Graph, Tree, String.",
      tags: ["Tiếng Anh", "Miễn phí", "Must-do"],
      url: "https://leetcode.com/discuss/general-discussion/460599/blind-75-leetcode-questions",
    },
    {
      icon: "🤝",
      name: "Pramp",
      platform: "pramp.com",
      desc: "Mock interview miễn phí peer-to-peer. Luyện phỏng vấn trực tiếp với người thật theo lịch hẹn — behavioral + coding.",
      tags: ["Tiếng Anh", "Miễn phí", "Mock Interview"],
      url: "https://www.pramp.com/",
    },
    {
      icon: "🗣️",
      name: "interviewing.io",
      platform: "interviewing.io",
      desc: "Mock interview ẩn danh với kỹ sư FAANG thực tế. Nhận feedback chuyên sâu và cơ hội kết nối với nhà tuyển dụng nếu làm tốt.",
      tags: ["Tiếng Anh", "Freemium", "Mock Interview"],
      url: "https://interviewing.io/",
    },
    {
      icon: "💻",
      name: "HackerRank",
      platform: "hackerrank.com",
      desc: "Luyện code theo domain: Algorithms, DS, SQL, Python, Java, C++. Có certification được nhiều công ty Việt Nam công nhận.",
      tags: ["Tiếng Anh", "Freemium", "Practice"],
      url: "https://www.hackerrank.com/",
    },
    {
      icon: "🧮",
      name: "Codeforces",
      platform: "codeforces.com",
      desc: "Nền tảng competitive programming quốc tế. Tham gia contest thường xuyên để nâng cao rating và tư duy giải thuật nhanh.",
      tags: ["Tiếng Anh", "Miễn phí", "Competitive"],
      url: "https://codeforces.com/",
    },
    {
      icon: "🎲",
      name: "AlgoExpert",
      platform: "algoexpert.io",
      desc: "160+ bài phỏng vấn với video giải thích chi tiết từng bước. Được thiết kế bởi các kỹ sư Google, Facebook với lộ trình rõ ràng.",
      tags: ["Tiếng Anh", "Có phí", "DSA"],
      url: "https://www.algoexpert.io/",
    },
    {
      icon: "🗃️",
      name: "SQL Interview Questions",
      platform: "leetcode.com/studyplan",
      desc: "Bộ câu hỏi SQL thực chiến: JOINs, Subqueries, Window Functions, CTEs, Index Optimization. Bắt buộc nếu ứng tuyển Data/Backend.",
      tags: ["Tiếng Anh", "Miễn phí", "Database/SQL"],
      url: "https://leetcode.com/studyplan/top-sql-50/",
    },
    {
      icon: "🖥️",
      name: "OS Interview Questions",
      platform: "geeksforgeeks.org",
      desc: "Câu hỏi phỏng vấn về Hệ điều hành: Process, Thread, Deadlock, Memory Management, Scheduling, File System và Virtual Memory.",
      tags: ["Tiếng Anh", "Miễn phí", "OS/CS"],
      url: "https://www.geeksforgeeks.org/operating-systems-interview-questions/",
    },
    {
      icon: "🌐",
      name: "Network Interview Questions",
      platform: "geeksforgeeks.org",
      desc: "Câu hỏi về Mạng máy tính: TCP/IP, HTTP/HTTPS, DNS, Load Balancer, WebSocket, REST vs GraphQL — thường gặp ở phỏng vấn Backend.",
      tags: ["Tiếng Anh", "Miễn phí", "Networking"],
      url: "https://www.geeksforgeeks.org/computer-network-interview-questions/",
    },
    {
      icon: "💬",
      name: "Behavioral Interview Guide",
      platform: "techinterviewhandbook.org",
      desc: "Hướng dẫn trả lời câu hỏi behavioral (STAR method): Tell me about yourself, Strengths/Weaknesses, Conflict handling...",
      tags: ["Tiếng Anh", "Miễn phí", "Soft Skills"],
      url: "https://www.techinterviewhandbook.org/behavioral-interview/",
    },
  ],

  /* ─────────────── GITHUB ─────────────── */
  "github": [
    {
      icon: "📖",
      name: "Coding Interview University",
      platform: "github.com/jwasham",
      desc: "Kế hoạch học toàn diện để chuẩn bị phỏng vấn FAANG. Một trong những repo được star nhiều nhất mọi thời đại trên GitHub.",
      tags: ["Tiếng Anh", "DSA", "Interview"],
      url: "https://github.com/jwasham/coding-interview-university",
      highlight: true,
      stars: "307k+",
    },
    {
      icon: "🏗️",
      name: "System Design Primer",
      platform: "github.com/donnemartin",
      desc: "Tài nguyên học thiết kế hệ thống phân tán scale lớn. Bắt buộc phải xem trước khi phỏng vấn System Design tại bất kỳ công ty nào.",
      tags: ["Tiếng Anh", "System Design", "Architecture"],
      url: "https://github.com/donnemartin/system-design-primer",
      highlight: true,
      stars: "285k+",
    },
    {
      icon: "📚",
      name: "Free Programming Books",
      platform: "github.com/EbookFoundation",
      desc: "Danh sách khổng lồ sách lập trình miễn phí theo ngôn ngữ và chủ đề. Có tài liệu tiếng Việt, hơn 50 ngôn ngữ lập trình.",
      tags: ["Đa ngôn ngữ", "Books", "All Levels"],
      url: "https://github.com/EbookFoundation/free-programming-books",
      stars: "341k+",
    },
    {
      icon: "🛠️",
      name: "Build Your Own X",
      platform: "github.com/codecrafters-io",
      desc: "Hướng dẫn tự xây dựng các công nghệ từ đầu: Git, Docker, Redis, Web Server, Database, Compiler. Học sâu bằng cách tự làm.",
      tags: ["Tiếng Anh", "Project-based", "Deep Dive"],
      url: "https://github.com/codecrafters-io/build-your-own-x",
      stars: "305k+",
    },
    {
      icon: "🌟",
      name: "Awesome Lists",
      platform: "github.com/sindresorhus",
      desc: "Bộ sưu tập mọi thứ tuyệt vời về lập trình: frameworks, tools, resources theo từng chủ đề. Điểm xuất phát tìm kiếm bất cứ gì.",
      tags: ["Tiếng Anh", "Curated List", "All Topics"],
      url: "https://github.com/sindresorhus/awesome",
      stars: "332k+",
    },
    {
      icon: "🎒",
      name: "Project Based Learning",
      platform: "github.com/practical-tutorials",
      desc: "Tổng hợp các tutorial dạy lập trình qua dự án thực tế theo mọi ngôn ngữ và công nghệ. Học bằng cách xây dựng ứng dụng thực.",
      tags: ["Tiếng Anh", "Project-based", "Practical"],
      url: "https://github.com/practical-tutorials/project-based-learning",
      stars: "212k+",
    },
    {
      icon: "⚡",
      name: "The Algorithms",
      platform: "github.com/TheAlgorithms",
      desc: "Implementation của mọi giải thuật phổ biến bằng Python, Java, C++, JavaScript. Học giải thuật trực quan từ source code có chú thích.",
      tags: ["Tiếng Anh", "Algorithms", "Multi-language"],
      url: "https://github.com/TheAlgorithms/Python",
      stars: "196k+",
    },
    {
      icon: "🧩",
      name: "30 Seconds of Code",
      platform: "github.com/Chalarangelo",
      desc: "Hàng nghìn code snippet JavaScript/Python/CSS hữu ích, mỗi snippet đọc trong 30 giây. Thư viện pattern lập trình thực tiễn.",
      tags: ["Tiếng Anh", "Snippets", "Practical"],
      url: "https://github.com/Chalarangelo/30-seconds-of-code",
      stars: "121k+",
    },
    {
      icon: "📘",
      name: "You Don't Know JS",
      platform: "github.com/getify",
      desc: "Series sách JavaScript miễn phí đào sâu cơ chế hoạt động bên trong: Scope, Closures, this, Prototypes, Async, ES6+.",
      tags: ["Tiếng Anh", "JavaScript", "Deep Dive"],
      url: "https://github.com/getify/You-Dont-Know-JS",
      stars: "179k+",
    },
    {
      icon: "✅",
      name: "Front-End Checklist",
      platform: "github.com/thedaviddias",
      desc: "Danh sách kiểm tra toàn diện trước khi deploy ứng dụng web: Performance, SEO, Accessibility, Security, Browsers và hơn 100 mục.",
      tags: ["Tiếng Anh", "Frontend", "Best Practices"],
      url: "https://github.com/thedaviddias/Front-End-Checklist",
      stars: "68k+",
    },
    {
      icon: "🧼",
      name: "Clean Code JavaScript",
      platform: "github.com/ryanmcdermott",
      desc: "Áp dụng nguyên tắc Clean Code vào JavaScript. Tên biến, functions, SOLID principles, Testing — code như senior developer.",
      tags: ["Tiếng Anh", "JavaScript", "Best Practices"],
      url: "https://github.com/ryanmcdermott/clean-code-javascript",
      stars: "92k+",
    },
    {
      icon: "🔥",
      name: "JavaScript Questions",
      platform: "github.com/lydiahallie",
      desc: "Câu hỏi JavaScript từ cơ bản đến nâng cao kèm giải thích chi tiết. Luyện hiểu sâu JavaScript engine, event loop, closures.",
      tags: ["Tiếng Anh", "JavaScript", "Interview"],
      url: "https://github.com/lydiahallie/javascript-questions",
      stars: "59k+",
    },
    {
      icon: "🟢",
      name: "Node.js Best Practices",
      platform: "github.com/goldbergyoni",
      desc: "Hơn 80 best practices cho Node.js production: error handling, code structure, testing, security, performance và Docker.",
      tags: ["Tiếng Anh", "Node.js", "Best Practices"],
      url: "https://github.com/goldbergyoni/nodebestpractices",
      stars: "99k+",
    },
    {
      icon: "🇻🇳",
      name: "VNOI — Cộng đồng lập trình VN",
      platform: "github.com/VNOI-Admin",
      desc: "Tổ chức GitHub của cộng đồng lập trình Việt Nam: source code online judge, tài liệu thuật toán và project mã nguồn mở.",
      tags: ["Tiếng Việt", "Community", "Competitive"],
      url: "https://github.com/VNOI-Admin",
    },
    {
      icon: "📡",
      name: "Public APIs",
      platform: "github.com/public-apis",
      desc: "Danh sách hàng nghìn API công khai miễn phí để làm dự án: Weather, Finance, Music, Movies, Sports, AI và nhiều hơn nữa.",
      tags: ["Tiếng Anh", "APIs", "Project Ideas"],
      url: "https://github.com/public-apis/public-apis",
      stars: "320k+",
    },
    {
      icon: "💡",
      name: "App Ideas Collection",
      platform: "github.com/florinpop17",
      desc: "Bộ sưu tập ý tưởng project từ Beginner đến Advanced. Hết ý tưởng làm project? Vào đây ngay — có cả yêu cầu cụ thể cho từng project.",
      tags: ["Tiếng Anh", "Project Ideas", "All Levels"],
      url: "https://github.com/florinpop17/app-ideas",
      stars: "72k+",
    },
  ],

  /* ─────────────── KHÓA HỌC ─────────────── */
  "khoa-hoc": [
    {
      icon: "🎓",
      name: "CS50 — Introduction to CS",
      platform: "cs50.harvard.edu",
      desc: "Khóa học Computer Science miễn phí nổi tiếng nhất thế giới của Harvard. C, Python, SQL, Web, AI. Cấp chứng chỉ Harvard miễn phí.",
      tags: ["Tiếng Anh", "Miễn phí", "Certificate"],
      url: "https://cs50.harvard.edu/x/",
      highlight: true,
    },
    {
      icon: "⚒️",
      name: "The Odin Project",
      platform: "theodinproject.com",
      desc: "Chương trình Full Stack Web Development miễn phí và mã nguồn mở. HTML/CSS, JavaScript, Node.js, React theo dự án thực tế.",
      tags: ["Tiếng Anh", "Miễn phí", "Full Stack"],
      url: "https://www.theodinproject.com/",
      highlight: true,
    },
    {
      icon: "🏕️",
      name: "freeCodeCamp",
      platform: "freecodecamp.org",
      desc: "Học Web Development với 3000+ giờ nội dung. Certifications về Responsive Web, JavaScript, Python, Data Science, ML with Python.",
      tags: ["Tiếng Anh", "Miễn phí", "Certificate"],
      url: "https://www.freecodecamp.org/",
    },
    {
      icon: "🏛️",
      name: "MIT OpenCourseWare",
      platform: "ocw.mit.edu",
      desc: "Toàn bộ tài liệu, bài giảng, problem sets của MIT miễn phí: Algorithms, OS, Networks, Compilers, AI, Computer Vision.",
      tags: ["Tiếng Anh", "Miễn phí", "University Level"],
      url: "https://ocw.mit.edu/",
    },
    {
      icon: "🤖",
      name: "fast.ai — Practical Deep Learning",
      platform: "fast.ai",
      desc: "Học Deep Learning thực tế từ trên xuống: code trước, lý thuyết sau. Phương pháp học AI hiệu quả nhất hiện nay cho người mới.",
      tags: ["Tiếng Anh", "Miễn phí", "AI/ML"],
      url: "https://course.fast.ai/",
      highlight: true,
    },
    {
      icon: "🧠",
      name: "Google ML Crash Course",
      platform: "developers.google.com",
      desc: "Khóa Machine Learning cấp tốc của Google Engineers. Học ML fundamentals với TensorFlow, thực hành qua interactive exercises.",
      tags: ["Tiếng Anh", "Miễn phí", "AI/ML"],
      url: "https://developers.google.com/machine-learning/crash-course",
    },
    {
      icon: "🔵",
      name: "Microsoft Learn",
      platform: "learn.microsoft.com",
      desc: "Học Microsoft technologies: Azure, .NET, Power Platform, AI/Copilot. Có lộ trình học rõ ràng và chuẩn bị thi chứng chỉ Microsoft.",
      tags: ["Tiếng Anh", "Miễn phí", "Certificate"],
      url: "https://learn.microsoft.com/",
    },
    {
      icon: "🟠",
      name: "Google Digital Garage",
      platform: "learndigital.withgoogle.com",
      desc: "Các khóa học kỹ năng số của Google: Digital Marketing, Data & Tech, Career Development. Chứng chỉ được Google công nhận toàn cầu.",
      tags: ["Đa ngôn ngữ", "Miễn phí", "Certificate"],
      url: "https://learndigital.withgoogle.com/digitalgarage",
    },
    {
      icon: "☁️",
      name: "AWS Skill Builder",
      platform: "skillbuilder.aws",
      desc: "500+ khóa học miễn phí của Amazon: Cloud Practitioner, Developer, Solutions Architect, Machine Learning. Chuẩn bị chứng chỉ AWS.",
      tags: ["Tiếng Anh", "Freemium", "Cloud/AWS"],
      url: "https://skillbuilder.aws/",
    },
    {
      icon: "📊",
      name: "Coursera — Free Audit",
      platform: "coursera.org",
      desc: "Hàng nghìn khóa học từ Stanford, DeepLearning.AI, Google, Meta. Audit (học thử toàn bộ nội dung) hoàn toàn miễn phí.",
      tags: ["Tiếng Anh", "Freemium", "University Level"],
      url: "https://www.coursera.org/",
    },
    {
      icon: "🎮",
      name: "Scrimba",
      platform: "scrimba.com",
      desc: "Nền tảng học Frontend tương tác độc đáo — chỉnh sửa code ngay trong video. Học React, JavaScript, TypeScript, CSS theo cách sáng tạo.",
      tags: ["Tiếng Anh", "Freemium", "Frontend/Interactive"],
      url: "https://scrimba.com/",
    },
    {
      icon: "🔴",
      name: "edX — Free Audit",
      platform: "edx.org",
      desc: "Khóa học từ Harvard, MIT, Berkeley, Microsoft. Audit miễn phí toàn bộ nội dung. Trả phí nếu muốn nhận certificate chính thức.",
      tags: ["Tiếng Anh", "Freemium", "University Level"],
      url: "https://www.edx.org/",
    },
    {
      icon: "🐍",
      name: "Python for Everybody — Coursera",
      platform: "coursera.org/specializations/python",
      desc: "Specialization Python của ĐH Michigan — phổ biến nhất trên Coursera. Từ cơ bản đến Web, Database và Data Visualization.",
      tags: ["Tiếng Anh", "Freemium", "Python"],
      url: "https://www.coursera.org/specializations/python",
    },
    {
      icon: "🌐",
      name: "The Web Developer Bootcamp",
      platform: "udemy.com",
      desc: "Khóa học Web phổ biến nhất Udemy của Colt Steele. HTML, CSS, JavaScript, Node.js, Express, MongoDB và React. Mua khi sale < 300k.",
      tags: ["Tiếng Anh", "Có phí", "Full Stack"],
      url: "https://www.udemy.com/course/the-web-developer-bootcamp/",
    },
    {
      icon: "🎯",
      name: "Stanford Online — Free Courses",
      platform: "online.stanford.edu",
      desc: "Các khóa học miễn phí từ Stanford: ML (Andrew Ng), Algorithms, Databases, AI. Đây là nơi bắt đầu của nhiều khóa học huyền thoại.",
      tags: ["Tiếng Anh", "Freemium", "University Level"],
      url: "https://online.stanford.edu/free-courses",
    },
    {
      icon: "🔗",
      name: "Kaggle Learn",
      platform: "kaggle.com/learn",
      desc: "Các mini-course miễn phí về Python, ML, Deep Learning, Data Visualization, SQL. Thi ngay sau mỗi bài và nhận certificate ngay.",
      tags: ["Tiếng Anh", "Miễn phí", "Data Science"],
      url: "https://www.kaggle.com/learn",
    },
  ],

  /* ─────────────── NCKH ─────────────── */
  "nckh": [
    {
      icon: "🔍",
      name: "Google Scholar",
      platform: "scholar.google.com",
      desc: "Công cụ tìm kiếm bài báo khoa học lớn nhất thế giới. Tìm paper theo chủ đề, xem số lần trích dẫn, theo dõi tác giả và nhận alert.",
      tags: ["Đa ngôn ngữ", "Miễn phí", "Tìm kiếm"],
      url: "https://scholar.google.com/",
      highlight: true,
    },
    {
      icon: "📡",
      name: "Papers With Code",
      platform: "paperswithcode.com",
      desc: "Tổng hợp các bài báo AI/ML kèm source code thực thi. Tìm State-of-the-Art của mọi task, so sánh benchmark và reproduce kết quả.",
      tags: ["Tiếng Anh", "Miễn phí", "AI/ML"],
      url: "https://paperswithcode.com/",
      highlight: true,
    },
    {
      icon: "🌐",
      name: "arXiv.org",
      platform: "arxiv.org",
      desc: "Kho preprint mở của Cornell University — đọc miễn phí mọi bài báo về CS, AI, Math, Physics trước khi publish. Cập nhật hàng ngày.",
      tags: ["Tiếng Anh", "Miễn phí", "Preprint"],
      url: "https://arxiv.org/",
      highlight: true,
    },
    {
      icon: "🔬",
      name: "IEEE Xplore",
      platform: "ieeexplore.ieee.org",
      desc: "Cơ sở dữ liệu bài báo IEEE — tổ chức kỹ thuật lớn nhất thế giới. Nhiều bài báo về AI, Signal Processing, Networks, Robotics.",
      tags: ["Tiếng Anh", "Freemium", "Engineering"],
      url: "https://ieeexplore.ieee.org/",
    },
    {
      icon: "📚",
      name: "ACM Digital Library",
      platform: "dl.acm.org",
      desc: "Thư viện số của ACM — tổ chức CS lớn nhất thế giới. Bao gồm bài báo từ các hội nghị top như SIGKDD, WWW, CHI, PLDI.",
      tags: ["Tiếng Anh", "Freemium", "Computer Science"],
      url: "https://dl.acm.org/",
    },
    {
      icon: "🧬",
      name: "Semantic Scholar",
      platform: "semanticscholar.org",
      desc: "Công cụ tìm kiếm paper AI-powered của Allen Institute. Hiểu ngữ nghĩa, tóm tắt nội dung tự động và gợi ý paper liên quan.",
      tags: ["Tiếng Anh", "Miễn phí", "AI-powered"],
      url: "https://www.semanticscholar.org/",
    },
    {
      icon: "🔗",
      name: "Connected Papers",
      platform: "connectedpapers.com",
      desc: "Visualize mạng lưới các bài báo liên quan dưới dạng đồ thị. Khám phá literature review theo kiểu trực quan — rất hữu ích khi bắt đầu nghiên cứu.",
      tags: ["Tiếng Anh", "Freemium", "Visualization"],
      url: "https://www.connectedpapers.com/",
    },
    {
      icon: "📖",
      name: "ResearchGate",
      platform: "researchgate.net",
      desc: "Mạng xã hội học thuật cho nhà nghiên cứu. Đọc paper, theo dõi tác giả, đặt câu hỏi trực tiếp, tìm cộng tác viên và chia sẻ nghiên cứu.",
      tags: ["Tiếng Anh", "Miễn phí", "Networking"],
      url: "https://www.researchgate.net/",
    },
    {
      icon: "🗂️",
      name: "Zotero",
      platform: "zotero.org",
      desc: "Phần mềm quản lý tài liệu tham khảo miễn phí và mã nguồn mở. Thu thập, tổ chức, trích dẫn và chia sẻ tài liệu nghiên cứu dễ dàng.",
      tags: ["Đa ngôn ngữ", "Miễn phí", "Reference Manager"],
      url: "https://www.zotero.org/",
      highlight: true,
    },
    {
      icon: "📋",
      name: "Mendeley",
      platform: "mendeley.com",
      desc: "Phần mềm quản lý tài liệu của Elsevier. Annotate PDF, organize library, generate citations (APA, IEEE, Vancouver) và collaborate nhóm.",
      tags: ["Tiếng Anh", "Miễn phí", "Reference Manager"],
      url: "https://www.mendeley.com/",
    },
    {
      icon: "✍️",
      name: "Overleaf — LaTeX Online",
      platform: "overleaf.com",
      desc: "Editor LaTeX online cộng tác thời gian thực. Template sẵn cho paper IEEE, ACM, Springer. Compile PDF trực tiếp, không cần cài đặt.",
      tags: ["Tiếng Anh", "Freemium", "LaTeX/Writing"],
      url: "https://www.overleaf.com/",
    },
    {
      icon: "🧠",
      name: "Elicit — AI Research Assistant",
      platform: "elicit.com",
      desc: "AI tìm kiếm và tóm tắt paper nghiên cứu tự động. Trả lời câu hỏi nghiên cứu bằng cách phân tích hàng nghìn paper liên quan.",
      tags: ["Tiếng Anh", "Freemium", "AI-powered"],
      url: "https://elicit.com/",
    },
    {
      icon: "🔭",
      name: "Research Rabbit",
      platform: "researchrabbit.ai",
      desc: "Công cụ AI khám phá literature — giống Spotify nhưng cho bài báo khoa học. Visualize citation network và tìm paper liên quan tự động.",
      tags: ["Tiếng Anh", "Miễn phí", "AI-powered"],
      url: "https://www.researchrabbit.ai/",
    },
    {
      icon: "🇻🇳",
      name: "VNU Journal of Science",
      platform: "js.vnu.edu.vn",
      desc: "Tạp chí khoa học của Đại học Quốc gia Hà Nội — đăng bài tiếng Việt và tiếng Anh. Hướng dẫn viết và nộp bài nghiên cứu trong nước.",
      tags: ["Tiếng Việt", "Miễn phí", "Tạp chí VN"],
      url: "https://js.vnu.edu.vn/",
    },
    {
      icon: "🌍",
      name: "DBLP — CS Bibliography",
      platform: "dblp.org",
      desc: "Cơ sở dữ liệu thư mục Computer Science toàn diện nhất. Tìm publication record của bất kỳ nhà nghiên cứu CS nào trên thế giới.",
      tags: ["Tiếng Anh", "Miễn phí", "Bibliography"],
      url: "https://dblp.org/",
    },
    {
      icon: "📊",
      name: "Scopus",
      platform: "scopus.com",
      desc: "Cơ sở dữ liệu trích dẫn khoa học lớn của Elsevier. Phân tích impact factor, H-index, journal ranking và xu hướng nghiên cứu theo lĩnh vực.",
      tags: ["Tiếng Anh", "Có phí", "Impact Metrics"],
      url: "https://www.scopus.com/",
    },
    {
      icon: "🏆",
      name: "Conference Ranks — CS",
      platform: "core.edu.au",
      desc: "Xếp hạng hội nghị và tạp chí Computer Science của CORE (A*, A, B, C). Tham khảo khi chọn venue nộp bài nghiên cứu.",
      tags: ["Tiếng Anh", "Miễn phí", "Conference Rank"],
      url: "https://portal.core.edu.au/conf-ranks/",
    },
    {
      icon: "🗺️",
      name: "Hướng dẫn NCKH cho SV",
      platform: "research.gov.vn",
      desc: "Cổng thông tin NCKH của Bộ KH&CN Việt Nam: đề tài cấp Bộ, cấp Trường, quy trình đăng ký và hỗ trợ tài chính cho sinh viên NCKH.",
      tags: ["Tiếng Việt", "Miễn phí", "Hướng dẫn VN"],
      url: "https://www.most.gov.vn/",
    },
    {
      icon: "💬",
      name: "ChatPDF / Summari",
      platform: "chatpdf.com",
      desc: "Upload PDF bài báo và hỏi AI câu hỏi về nội dung. Đọc nhanh abstract, methodology, kết quả và limitations của paper dài.",
      tags: ["Tiếng Anh", "Freemium", "AI Tool"],
      url: "https://www.chatpdf.com/",
    },
    {
      icon: "📝",
      name: "Grammarly — Academic Writing",
      platform: "grammarly.com",
      desc: "Công cụ kiểm tra ngữ pháp, spelling và style tiếng Anh học thuật. Bắt buộc dùng khi viết paper bằng tiếng Anh để tránh lỗi cơ bản.",
      tags: ["Tiếng Anh", "Freemium", "Writing Tool"],
      url: "https://www.grammarly.com/",
    },
  ],
};
